(function(){
    angular
        .module('appback')
        .filter('ngnumberfilter', numberFilter);
  
        numberFilter.$inject = ['$filter'];
        function numberFilter($filter) { 
            return function(string) 
            {
                string = $filter('number')(string,4).replaceAll(".", '').replaceAll(",", '.');
                return string;
            }

        }
  })();